import { jsx as _jsx } from "react/jsx-runtime";
import { ConfirmationModal } from "@air/component-confirmation-modal";
export const ContentCollectionApplyAllModal = (param)=>{
    let { onClose, onApplyAll } = param;
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        id: "content-collection-apply-all-modal",
        isOpen: true,
        onConfirm: onClose,
        onDismiss: onApplyAll,
        title: "Keep existing fields?",
        description: "Applying details to all items will overwrite any fields you’ve entered individually. You can choose to keep your current selections or replace all values.",
        ctaPrimaryText: "Keep existing fields",
        ctaSecondaryText: "Overwrite all"
    });
};
